import { ReactNode } from 'react'
import cx from 'classnames'
import styles from './Callout.module.css'

/** 시안 `.cal` `.cal.c` `.cal.w` 이식. */
export type CalloutProps = {
  tone?: 'neutral' | 'good' | 'warn' | 'crit'
  children: ReactNode
}

export const Callout = ({ tone = 'neutral', children }: CalloutProps): JSX.Element => (
  <div className={cx(styles.cal, tone === 'good' && styles.good, tone === 'warn' && styles.warn, tone === 'crit' && styles.crit)}>{children}</div>
)
